module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/pos/itemlists/itemlists-show/itemlists-show.component.scss
// module id = ./src/app/views/pos/itemlists/itemlists-show/itemlists-show.component.scss
// module chunks = main